// @flow
import { createContext } from 'react';

export const SPOrgContext = createContext({});
